export default "/images/bookmark-full.svg?e1e9164b97baabd9d574b32ef78befb5";